import {authenticatedRoutes as manifest} from '@tenant/core/routes';
import resolveWebRoutes from './resolve';

/**
 * Authenticated web routes.
 *
 * Route *data* lives in the shared manifest at
 * `packages/core/routes/manifest.js`; this file only binds it to web screens
 * and icons. Output shape is unchanged from before the extraction.
 *
 * @param {object} args - Auth state plus `canAccessSelfCheck` / `hasProperties`.
 * @returns {object[]}
 */
const authenticatedRoutes = args =>
  resolveWebRoutes(manifest(args), {authenticated: true});

export default authenticatedRoutes;
